import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const Footer = () => {

  const main = process.env.REACT_APP_MAIN;

  return (
    <div className="footer__container">
      <div className="footer">
        <div className="footer__child">
          <div>
            <h3>SOBRE</h3>
            <p>
            Com Conselho Editorial composto por 12 professores doutores, nacionais e estrangeiros, a Editora Insigne Acadêmica fará todo o acompanhamento e registro de sua obra.
            </p>
          </div>

          <div className="footer-icons">
            <h3>REDES</h3>
            <div className="footer-icons-content">
              <i className="uil uil-facebook-f"></i>
              <i className="uil uil-instagram"></i>
              <i className="uil uil-whatsapp"></i>
            </div>
          </div>
        </div>

        
        <div className="footer__child footer__menu">
          <h3>SUPORTE</h3>

          <a href="https://wa.me/5584994514529" target="_blank" rel="noreferrer">
            Contato
          </a>
        </div>
      

        <div className="footer__child footer__menu">
          <h3>MENU</h3>

          <Link to={main} onClick={scrollToTop}>
            Início
          </Link>

          <Link to={main + "livros/"} onClick={scrollToTop}>
            Livros
          </Link>

          <Link to={main + "contato/"} onClick={scrollToTop}>
            Contato
          </Link>
        </div>
      </div>

      <div className="copy__container">
        <div className="copy">
          {" "}
          <p>
            Desenvolvido por{" "}
            <a href="https://jacquesgomes.com.br/portfolio/">Jacques Gomes</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
